<div class="data_card">
    <div class="general lilly">
        <div class="avatar_container">
            <img class="avatar" alt="Lilly Avatar" src="../../../../assets/img/lilly-head-50x50.webp">
        </div>
        <div class="personal_info">
            <p style="font-weight: bold;">Lilly</p>
            <p>Zimmermann</p>
        </div>
        <div class="age_info">
            <p style="font-weight: bold;">Alter</p>
            <p>{{age}}</p>
        </div>
    </div>
    <div class="infos">
        <div class="line">
            <p style="font-weight: bold;">Jobrole</p>
            <p>Front Yard Predator</p>
        </div>
        <div class="line">
            <p style="font-weight: bold;">Company</p>
            <p>Zimmermann Security</p>
        </div>
        <div class="line">
            <p style="font-weight: bold;">Level</p>
            <p>Professional</p>
        </div>
        <div class="line">
            <p style="font-weight: bold;">Entry</p>
            <p>Februar 2021</p>
        </div>                            
    </div>
</div>